import { Colors } from '@/common/colors/colors';
import Icon from '@/common/components/Icon';
import { SPEND_SOURCES } from '@/common/constants/spend_sources';

export const getMetaAccountTableRows = (data, onActionClick, onActionSync) => {
	return data?.map((metaAccount) => (
		<tr key={metaAccount.name}>
			<td>{metaAccount.email}</td>
			<td>{metaAccount._add_account.filter((acc) => acc.is_active).length}</td>
			<td>{metaAccount._add_account.filter((acc) => !acc.is_active).length}</td>
			<td>
				<div style={{ display: 'flex', gap: '10px' }}>
					<Icon
						name='edit'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
						}}
						onClick={() => onActionClick(metaAccount)}
					/>
					<Icon
						name='sync'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
						}}
						onClick={() => onActionSync(metaAccount)}
					/>
				</div>
			</td>
		</tr>
	));
};

export const getAddAccountTableRows = (data, onActionClick) => {
	return data?.map((metaAccount) =>
		metaAccount._add_account.map((addAccount) => (
			<tr key={addAccount.name}>
				<td>{addAccount.name}</td>
				<td>
					{addAccount.source &&
						SPEND_SOURCES.find((opt) => opt.value === addAccount.source)?.label}
				</td>
				<td>{addAccount.add_account_id}</td>
				<td>
					{addAccount.is_active ? (
						<Icon name='check' style={{ color: Colors.green }} />
					) : (
						<Icon name='xmark' style={{ color: Colors.red }} />
					)}
				</td>
				<td>
					<Icon
						name='edit'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
						}}
						onClick={() => onActionClick(addAccount)}
					/>
				</td>
			</tr>
		)),
	);
};
